module.exports = __webpack_public_path__ + "img/feedback.747d5e01.svg";